<div class="text-diff">
  <div class="text-diff__column">
    <h2 class="text-diff__title">Texto Original</h2>
    <div class="text-diff__content">
      <span class="text-diff__text" >
       {{oldText}}

      </span>
    </div>
  </div>
  <div class="text-diff__column">
    <h2 class="text-diff__title">Texto Modificado</h2>
    <div class="text-diff__content">
      <span *ngFor="let diff of diffs">
        <span *ngIf="diff[0] === 0"class="text-diff__text">{{ diff[1] }}</span>
         <span *ngIf="diff[0] === -1" class="text-diff__text text-diff__text-removed">{{ diff[1] }}</span>
        <span *ngIf="diff[0] === 1" class="text-diff__text text-diff__text-added">{{ diff[1] }}</span>
      </span>
    </div>
  </div>
</div>
